import React from 'react';

import { InfoHero } from '../common';

const FreeTrialHeroSection: React.FC = () => {
  return <InfoHero>The Woosa Sleep Trial</InfoHero>;
};

export default FreeTrialHeroSection;
